import React from 'react';

interface RefreshIconProps {
  size?: number;
  className?: string;
}

/**
 * Refresh icon for reload/sync actions
 * Used for the "refresh from Gmail" functionality
 */
export const RefreshIcon: React.FC<RefreshIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M23 4v6h-6" />
    <path d="M1 20v-6h6" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

export default RefreshIcon;
